export const dataTestIds = {
	// Chat button
	chatbotButtonOpen: 'chatbot.button.open',
	// Chat form
	chatbotInputForm: 'chatbot.input.form',
	// About AI message
	aboutAIMessage: 'chatbot.about.ai',
	// Fashion Assistant Product
	fashionAssistantProduct: 'chatbot.fa.product',
	// Confirm close bottom sheet
	chatbotSheetConfirmClose: 'chatbot.sheet.confirmClose',
	// Confirm close dialog
	chatbotDialogConfirmClose: 'chatbot.dialog.confirmClose',
}
